/**
 * @file Provides the Waldo icons (blockers) and clipPath svg for photo obfuscation.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { blockerDataFromFacebox } from '../../../util/photo';
import { getAsset } from '../../../util/assets';

const propTypes = {
  id: PropTypes.string.isRequired,
  faceboxes: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired,
  obfuscatorMultiplier: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  renderSvg: PropTypes.bool,
  faceblockerImageUrl: PropTypes.string,
  blockerMinSizeThreshold: PropTypes.number,
  blockerMinSize: PropTypes.number,
  blockerMaxSize: PropTypes.number,
};

const PhotoFaceBlock = ({
  id,
  faceboxes,
  obfuscatorMultiplier = 1,
  renderSvg = true, // Compatibilty.
  faceblockerImageUrl = getAsset('/waldo-icon.svg'),
  blockerMinSizeThreshold,
  blockerMinSize,
  blockerMaxSize,
}) => {
  return (
    <Fragment>
      {renderSvg && !!obfuscatorMultiplier && (
        <svg width="100%" height="100%">
          <defs>
            <clipPath id={`clip-${id}`}>
              {faceboxes.map((facebox, index) => {
                const {
                  centerX,
                  centerY,
                  blockerSvgRadius,
                } = blockerDataFromFacebox(
                  facebox,
                  typeof obfuscatorMultiplier === 'number'
                    ? obfuscatorMultiplier
                    : obfuscatorMultiplier(facebox),
                  blockerMinSizeThreshold,
                  blockerMinSize,
                  blockerMaxSize,
                );

                return (
                  <circle
                    key={index}
                    cx={`${centerX * 100}%`}
                    cy={`${centerY * 100}%`}
                    r={`${blockerSvgRadius * 100}%`}
                  />
                );
              })}
            </clipPath>
          </defs>
        </svg>
      )}

      <div className="photo-face-block">
        {faceboxes.map((facebox, index) => {
          const { blockerX, blockerY, blockerSize } = blockerDataFromFacebox(
            facebox,
            typeof obfuscatorMultiplier === 'number'
              ? obfuscatorMultiplier
              : obfuscatorMultiplier(facebox),
            blockerMinSizeThreshold,
            blockerMinSize,
            blockerMaxSize,
          );

          return (
            <span
              key={index}
              className="face-blocker"
              style={{
                top: `${blockerY * 100}%`,
                left: `${blockerX * 100}%`,
                width: `${blockerSize * 100}%`,
                height: `${blockerSize * 100}%`,
                backgroundImage: faceblockerImageUrl
                  ? `url("${faceblockerImageUrl}")`
                  : '',
              }}
            />
          );
        })}
      </div>
    </Fragment>
  );
};

PhotoFaceBlock.propTypes = propTypes;

export default PhotoFaceBlock;
